import {Dispatch, FC, SetStateAction, useState} from 'react';
import {useForm} from 'react-hook-form';
import { findUserId } from '../../../apis/user';
import {Button} from '../../../components/Button';
import {PhoneNumber} from '../../../components/PhoneNumber';
import {TextField} from '../../../components/TextField';
import { nToast } from '../../../plugins/reactToast';

interface FormValues {
    phone: string;
}

interface FindIdUserFormProps {
    setIsShowUserId: (ids: string[]) => void
}

const FindPasswordForm: FC<FindIdUserFormProps> = ({setIsShowUserId}) => {
    const [isVerifiedPhone, setIsVerifiedPhone] = useState<boolean>(false);

    const {
        register,
        handleSubmit,
        watch,
        setValue,
        formState: {errors},
    } = useForm<FormValues>();
    const formValues = watch();

    const _onSubmit = async ({phone}: FormValues) => {
        findUserId(formValues).then(r => setIsShowUserId(r.data.payload)).catch(e => e.response.status === 403 && nToast(e.response.data.message));
    };

    return (
        <form
            className="flex flex-col space-y-4 mt-8"
            onSubmit={handleSubmit(_onSubmit)}>
            {/*<TextField
        label="이름"
        type="text"
        placeholder="이름을 입력해주세요."
        helper={errors.name?.message}
        {...register('name', {required: '이름을 입력해주세요.'})}
      />*/}
            <PhoneNumber
                label="핸드폰 번호"
                needVerify={true}
                onVerified={phone => {
                    setValue('phone', phone.replaceAll('-', ''));
                    setIsVerifiedPhone(true);
                }}
                disabled={isVerifiedPhone}
            />

            <Button
                disabled={!isVerifiedPhone || !formValues?.phone}
                type="submit"
                text="다음"
                className="filled-gray-900"
            />
        </form>
    );
};

export default FindPasswordForm;
